<template>
  <v-menu
    rounded
    offset-y
    left
    :close-on-content-click="false"
    max-height="70vh"
    transition="slide-y-transition"
    v-model="menu"
  >
    <template v-slot:activator="{ attrs, on }">
      <transition name="fade">
        <v-btn
          v-bind="attrs"
          v-on="on"
          x-large
          fixed
          color="white"
          right
          :class="[
            scrollUp ? 'cart-to-top' : 'cart-to-bottom',
            'rounded-lg primary--text cart-btn'
          ]"
          v-scroll.parent="onScroll"
        >
          Cart
          <v-icon right>mdi-cart</v-icon>
          <v-badge
            v-if="quantity > 0"
            color="red lighten-1"
            :content="quantity"
          ></v-badge>
        </v-btn>
      </transition>
    </template>

    <slot name="cart-items"></slot>

    <v-list v-if="quantity > 0">
      <!-- <div class="red lighten-1 white--text text-center">
				<h3 class="pt-2">Good for {{ quantity }} Person</h3>
				<p class="pb-2 caption">Maximum purchase: 100 pax</p>
			</div> -->

      <!-- Subtotal -->
      <v-row no-gutters align="center">
        <v-col cols="6" class="text-center grey lighten-2 pa-3">
          <span class="black--text font-weight-bold">Subtotal</span>
        </v-col>
        <v-col cols="6" style="border: 1px solid gray" class="text-center pa-3">
          <span class="font-weight-bold primary--text">
            <span class="peso" v-html="MIXIN_PESO_SIGN"></span>
            {{ total | numFormat("0.00") }}
          </span>
        </v-col>
      </v-row>

      <!-- Checkout button -->
      <v-row justify="center" class="mt-4 mb-3">
        <slot name="checkout-button"></slot>
      </v-row>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "CartMenuButton",
  data() {
    return {
      scrollPosition: 0,
      scrollUp: true,
      menu: false
    };
  },
  mounted() {
    //
  },
  computed: {
    quantity: function() {
      if (this.$route.name == "Shop" || this.$route.name == "Home")
        return this.$store.getters["cart/quantity"];
      else if (this.$route.name == "ShopMerchant")
        return this.$store.getters["merchantCart/quantity"];
      else return this.$store.getters["promoCart/quantity"];
    },
    total: function() {
      if (this.$route.name == "Shop" || this.$route.name == "Home")
        return this.$store.getters["cart/total"];
      else if (this.$route.name == "ShopMerchant")
        return this.$store.getters["merchantCart/total"];
      else return this.$store.getters["promoCart/total"];
    }
  },
  methods: {
    checkout() {
      this.$emit("checkout");
    },
    onScroll() {
      this.menu = false;
      let app = document.getElementsByTagName("html");

      var currentScrollPosition = app[0].scrollTop;

      this.scrollUp =
        currentScrollPosition > this.scrollPosition ? false : true;

      this.scrollPosition = currentScrollPosition;
    }
  },
  watch: {
    //
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.peso {
  font-family: Arial;
}

.cart-btn {
  z-index: 1;
}

.cart-to-top {
  margin-top: 140px;
  margin-right: 2%;

  @media (min-width: 600px) {
    margin-right: 7%;
  }
}

.cart-to-bottom {
  margin-top: 20px;
  margin-right: 3%;

  @media (min-width: 600px) {
    margin-right: 1%;
  }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $blue;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $dark-blue;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
